import React, {useState, useEffect} from 'react';
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter';
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioMaterial from './FormularioMaterial'
import favicon from '../imagenes/logoutm.png'
import Cargando from '../elementos/Cargando'

const EditarMaterial = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [material, setMaterial] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarMaterialID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setMaterial(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                    <div>
                        <Helmet>
                            <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                            <title>Actualizar Material</title>
                        </Helmet>
                    </div>
                </HelmetProvider>

                <Header>
                        <Titulo>Actualizar Material</Titulo>
                        <BtnRegresar ruta="/culturas"/>
                </Header>

                <FormularioMaterial  material={material}/>
            </>
        );
    }
}
 
export default withRouter(EditarMaterial);